export const ENTITY_MERGE_RECORDS_QUERY_KEY = 'entityMergeRecords'

// Merge types for API
export const MERGE_TYPES = {
  PEOPLE: 'PlatformPerson',
  ORGANIZATIONS: 'PlatformOrganization',
}

// Merge status values
export const MERGE_STATUS = {
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  FAILED: 'failed',
}

export const MERGE_STATUS_OPTIONS = [
  { label: 'In progress', value: MERGE_STATUS.IN_PROGRESS },
  { label: 'Completed', value: MERGE_STATUS.COMPLETED },
  { label: 'Failed', value: MERGE_STATUS.FAILED },
]

export const PEOPLE_MERGE_STEPS = [
  { label: 'Overview', key: 'overview' },
  { label: 'Multiple Jobs', key: 'multipleJobs' },
  { label: 'Preview & Merge', key: 'previewMerge' },
]

export const PEOPLE_COMPARISON_FIELDS = [
  { key: 'name', label: 'Name' },
  { key: 'email', label: 'Email' },
  { key: 'phone', label: 'Phone' },
  { key: 'organization', label: 'Organization' },
  { key: 'address', label: 'Address' },
  { key: 'multipleJobs', label: 'Multiple Jobs', expandable: true },
  {
    key: 'customEmail',
    label: 'Custom Emails',
    tooltip:
      'This count represents the aggregated total across all jobs associated with the profile.',
  },
  {
    key: 'customPhone',
    label: 'Custom Phone Numbers',
    tooltip:
      'This count represents the aggregated total across all jobs associated with the profile.',
  },
  {
    key: 'customFirstName',
    label: 'Preferred Names',
    tooltip:
      'This count represents the aggregated total across all jobs associated with the profile.',
  },
  { key: 'customField', label: 'Custom Fields' },
  { key: 'activity', label: 'Activities' },
  { key: 'tagging', label: 'Tags' },
  { key: 'note', label: 'Notes' },
  { key: 'internalNote', label: 'Internal Notes' },
  { key: 'task', label: 'Tasks' },
  { key: 'surveyResponse', label: 'Pulse Responses' },
  { key: 'customerFavoritePeople', label: 'Key Contacts' },
  { key: 'postmarkSuppression', label: 'Postmark Suppressions' },
]

// Core job fields used across multiple contexts
export const JOB_CORE_FIELDS = [
  { key: 'email', label: 'Email' },
  { key: 'phone', label: 'Phone' },
  { key: 'active', label: 'Job Status' },
]

// Extended job fields for detailed views
export const JOB_EXTENDED_FIELDS = [
  { key: 'organization', label: 'Organization' },
  { key: 'address', label: 'Address' },
  {
    key: 'activities',
    label: 'Activities',
    tooltip:
      'This count shows the merged total with duplicates removed. Records are combined, not overwritten.',
  },
]

// Full job details fields (core + extended)
export const JOB_DETAILS_DRAWER_FIELDS = [...JOB_CORE_FIELDS, ...JOB_EXTENDED_FIELDS]

export const PEOPLE_MERGE_PREVIEW_FIELDS = [
  { key: 'name', label: 'Name' },
  { key: 'email', label: 'Email' },
  { key: 'phone', label: 'Phone' },
  { key: 'jobFunction', label: 'Job function' },
  { key: 'organization', label: 'Organization' },
  { key: 'address', label: 'Address' },
  { key: 'customEmail', label: 'Custom emails' },
  { key: 'customPhone', label: 'Custom phone numbers' },
  { key: 'customFirstName', label: 'Preferred names' },
  { key: 'customField', label: 'Custom fields' },
  {
    key: 'activity',
    label: 'Aggregated activities',
    tooltip:
      'This count shows the merged total with duplicates removed. Records are combined, not overwritten.',
  },
  {
    key: 'tagging',
    label: 'Aggregated tags',
    tooltip:
      'This count shows the merged total with duplicates removed. Records are combined, not overwritten.',
  },
  {
    key: 'note',
    label: 'Aggregated notes',
    tooltip:
      'This count shows the merged total with duplicates removed. Records are combined, not overwritten.',
  },
  {
    key: 'task',
    label: 'Aggregated tasks',
    tooltip:
      'This count shows the merged total with duplicates removed. Records are combined, not overwritten.',
  },
  { key: 'linkedInUrl', label: 'LinkedIn URL' },
  { key: 'internalNote', label: 'Internal notes' },
  { key: 'surveyResponse', label: 'Pulse responses' },
  { key: 'customerFavoritePeople', label: 'Key contacts' },
  { key: 'postmarkSuppression', label: 'Postmark suppressions' },
]
